<template>
	<div>
        <b-overlay rounded="sm" class="">
            <b-card no-body class="border-0 bg-transparent no-shadow employee-tab-bg">
                <div class="d-inline-block w-100">
                    <div class="row pt-4">
                        <div class="col-md-3">
                            <div class="clearfix company-form-container h-100 p-3 payslip-list-dropdown">
                                <b-form-select v-model="fiscals" class="select_border_color2" v-on:change="filterFiscalYear">
                                    <b-form-select-option value='null' >Select Fiscal Year</b-form-select-option>
                                    <b-form-select-option v-for="(fiscal_year,index)  in fiscal_years" :key="index" :value="fiscal_year.fiscal_year">
                                        {{fiscal_year.fiscal_year}}
                                    </b-form-select-option>
                                </b-form-select>


                                <div class="col-md-12  payslip-month-list-item-container cursor-pointer" :class="{ 'active': activeIndex === index }" v-for="(payslip,index)  in payslips" :key="payslip.id" @click="paySlipLoad(payslip.id,index)">
                                    <template  v-if="$atl_company_package_title != 'Provident Fund Only'">
                                        <div class="payslip-month-list-item clearfix py-3 px-1"  >
                                            <div class="payslip-month-list-item-left" :class="{ 'table_text_color': activeIndex === index }">
                                                {{payslip.month}}
                                            </div>
                                            <div class="payslip-month-list-item-right" :class="{ 'table_text_color': activeIndex === index }">
                                                {{payslip.year}}
                                            </div>

                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="payslip-month-list-item clearfix py-3 px-1" :class="{ 'table_text_color': activeIndex === index }">
                                            <div class="payslip-month-list-item-left">
                                                {{payslip.month}}
                                            </div>
                                            <div class="payslip-month-list-item-right" :class="{ 'table_text_color': activeIndex === index }">
                                                {{payslip.year}}
                                            </div>
                                        </div>
                                    </template>
                                </div>

                            </div>
                        </div>

                        <div class="col-md-9" v-if="selected_payslip.id > 0">
                            <div class="clearfix company-form-container h-100 p-3">
                                <template  v-if="$atl_company_package_title != 'Provident Fund Only'">
                                    <Employeepayslipdetails :pageurl="$api_url" :dynamic_fields="dynamic_fields" :pmonth="selected_payslip.month" :pyear="selected_payslip.year" :payslip="selected_payslip.id" :key='detail_key' :company="companies[selected_payslip.company_id]" :payslipname="'Pay Slip for '+empdata.name+' (eTIN-'+empdata.etin+') - '+selected_payslip.month+' '+selected_payslip.year">
                                    </Employeepayslipdetails>
                                </template>
                                <template v-else>
                                    <Employeepfslipdetails :pageurl="$api_url" :dynamic_fields="dynamic_fields" :pmonth="selected_payslip.month" :pyear="selected_payslip.year" :payslip="selected_payslip.id" :key='detail_key' :company="companies[selected_payslip.company_id]" :payslipname="'PF Slip for '+empdata.name+' - '+selected_payslip.month+' '+selected_payslip.year" :emp_etin="empdata.etin" :emp_department="selected_payslip.department" :emp_jobposition="selected_payslip.jobposition"  :emp_branch="selected_payslip.branch_name" :emp_code="emp_public_info.employee_code" :emp_joining="emp_joinng_date"></Employeepfslipdetails>
                                </template>
                            </div>
                        </div>
                        <div class="col-md-9" v-else>
                            <div class="clearfix company-form-container h-100 p-3">
                                <div class='no-data-wrapper'>
                                    No Data found
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </b-card>
        </b-overlay>
	</div>
</template>


<script>
import moment from 'moment';
    export default{

        mounted() {
        },

        computed: {
        },

        components: {
           // Employeepayslipdetails
        },
        data(){
            return {

                payslips: [],
                empdata: [],
                emp_public_info: [],
                companies: [],
                accpayslips:[],
                fiscal_years: [],
                fiscals: null,
                curr_fiscal: [],
                emp_joinng_date: '',
                downloadable: 'yes',
                dynamic_fields:{},

                // Abdullah live in secure add here
                activeIndex: -1,
                 detail_key:0,

                 // Abdullah live in secure add here upto this
                selected_payslip:[],
            }
        },
        methods:{

            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },

            getEmployeePublicInfo: function()
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/employee/publicinfo' , {
                    params: {

                    }
                }).then(function(response){
                    this.emp_public_info = response.data;
                    this.getPayslipDynamicFieldData(this.emp_public_info.employee_id);
                    this.emp_joinng_date =  moment(String(response.data.date_of_joining)).format('D MMMM YYYY');

                }.bind(this));
            },
            getPayslipDynamicFieldData:function(emp_id)
            {
                axios.get(this.$api_url+'/company/payslip-field-settings/get-employee-dynamic-field-data', {
                            params: {
                                employee_id: emp_id
                            }
                    }).then(function(response){
                        var ltData = response.data;
                        this.dynamic_fields =ltData;

                }.bind(this));
            },
            getpayslips: function(f_year='')
            {

                   axios.get(this.$api_url+'/employeepaysliplists', {
                            params: {
                                fiscal_year: f_year
                            }
                    }).then(function(response){
                    this.payslips = response.data.data.payslips;
                    this.empdata = response.data.data.employee_info;
                    this.companies = response.data.data.companies;
                    this.fiscal_years = response.data.data.fiscal_years;
                    this.curr_fiscal = response.data.data.fiscal_year;
                    this.fiscals = response.data.data.fiscal_year;
                    this.downloadable = response.data.data.downloadable;

                    // Abdullah live in secure add here
                     if(this.payslips.length > 0){
                        this.selected_payslip  = this.payslips[0];
                        this.activeIndex = 0;
                    }
                    // Abdullah live in secure add here upto this
                }.bind(this));
            },
            // paySlipLoad(card_id){
            //     if(parseInt(card_id)){
            //     this.$set(this.accpayslips,card_id,1);
            //     }
            // },

            // Abdullah live in secure add here

            paySlipLoad(card_id,index){
                if(parseInt(card_id)){
                    this.$set(this.accpayslips,card_id,1);
                    this.activeIndex = index;
                    this.selected_payslip  = this.payslips.find(item => item.id === card_id);
                    console.log(card_id);
                    console.log(this.selected_payslip);

                    this.detail_key += 1;

                }
                else
                {
                    this.selected_payslip = [];
                    this.activeIndex = -1;
                    this.detail_key += 1;
                }
            },

            // Abdullah live in secure add here  uopto this

            filterFiscalYear(f_year){
                this.getpayslips(f_year);
            },
            onSubmit:function(e)
            {
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }

                e.preventDefault();
                let currentObj = this;



                });
            },


        },
        created: function(){
            this.getEmployeePublicInfo();
            this.getpayslips();
        }
    }
</script>
